import React from "react";
import "./App.css";
import { ThemeProvider } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import SkillsSection from "./components/SkillsSection";
import OpenSourceSection from "./components/OpenSourceSection";
import ProjectsSection from "./components/ProjectsSection";
import TimelineSection from "./components/TimelineSection";
import ImpactSection from "./components/ImpactSection";
import { ContactSection, Footer } from "./components/ContactFooter";

function App() {
  return (
    <ThemeProvider>
      <div className="App bg-zinc-50 dark:bg-zinc-950 min-h-screen transition-colors duration-500">
        <Navbar />
        <main>
          <HeroSection />
          <AboutSection />
          <SkillsSection />
          <OpenSourceSection />
          <ProjectsSection />
          <TimelineSection />
          <ImpactSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
